import { render } from "./ServicesCardControl.vue?vue&type=template&id=1053c1c0&scoped=true"
import script from "./ServicesCardControl.vue?vue&type=script&lang=js"
export * from "./ServicesCardControl.vue?vue&type=script&lang=js"

import "./ServicesCardControl.vue?vue&type=style&index=0&id=1053c1c0&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1053c1c0"]])

export default __exports__